import { Airport } from '../models/Airport';

export const airports: Airport[] = [
  {
    rank: 1,
    name: 'Hartsfield–Jackson Atlanta International Airport',
    location: 'Atlanta, Georgia',
    country: 'United States',
    countryCode: 'US',
    code: 'ATL/KATL',
    icao: 'KATL',
  },
  {
    rank: 2,
    name: 'Beijing Capital International Airport',
    location: 'Chaoyang-Shunyi, Beijing',
    country: 'China',
    countryCode: 'CN',
    code: 'PEK/ZBAA',
    icao: 'ZBAA',
  },
  {
    rank: 3,
    name: 'Los Angeles International Airport',
    location: 'Los Angeles, California',
    country: 'United States',
    countryCode: 'US',
    code: 'LAX/KLAX',
    icao: 'KLAX',
  },
  {
    rank: 4,
    name: 'Tokyo Haneda Airport',
    location: 'Ōta, Tokyo',
    country: 'Japan',
    countryCode: 'JP',
    code: 'HND/RJTT',
    icao: 'RJTT',
  },
  {
    rank: 5,
    name: 'Dubai International Airport',
    location: 'Garhoud, Dubai',
    country: 'United Arab Emirates',
    countryCode: 'AE',
    code: 'DXB/OMDB',
    icao: 'OMDB',
  },
  {
    rank: 6,
    name: 'O\'Hare International Airport',
    location: 'Chicago, Illinois',
    country: 'United States',
    countryCode: 'US',
    code: 'ORD/KORD',
    icao: 'KORD',
  },
  {
    rank: 7,
    name: 'London Heathrow Airport',
    location: 'Hillingdon, London',
    country: 'United Kingdom',
    countryCode: 'GB',
    code: 'LHR/EGLL',
    icao: 'EGLL',
  },
  {
    rank: 8,
    name: 'Shanghai Pudong International Airport',
    location: 'Pudong, Shanghai',
    country: 'China',
    countryCode: 'CN',
    code: 'PVG/ZSPD',
    icao: 'ZSPD',
  },
  {
    rank: 9,
    name: 'Hong Kong International Airport',
    location: 'Chek Lap Kok, Islands, New Territories',
    country: 'Hong Kong SAR, China',
    countryCode: 'HK',
    code: 'HKG/VHHH',
    icao: 'VHHH',
  },
  {
    rank: 10,
    name: 'Paris-Charles de Gaulle Airport',
    location: 'Roissy-en-France, Île-de-France',
    country: 'France',
    countryCode: 'FR',
    code: 'CDG/LFPG',
    icao: 'LFPG',
  },
  {
    rank: 11,
    name: 'Dallas/Fort Worth International Airport',
    location: 'Dallas-Fort Worth, Texas',
    country: 'United States',
    countryCode: 'US',
    code: 'DFW/KDFW',
    icao: 'KDFW',
  },
  {
    rank: 12,
    name: 'Guangzhou Baiyun International Airport',
    location: 'Baiyun-Huadu, Guangdong',
    country: 'China',
    countryCode: 'CN',
    code: 'CAN/ZGGG',
    icao: 'ZGGG',
  },
  {
    rank: 13,
    name: 'Seoul Incheon International Airport',
    location: 'Incheon',
    country: 'Republic of Korea',
    countryCode: 'KR',
    code: 'ICN/RKSI',
    icao: 'RKSI',
  },
  {
    rank: 14,
    name: 'Amsterdam Airport Schiphol',
    location: 'Haarlemmermeer, North Holland',
    country: 'The Netherlands',
    countryCode: 'NL',
    code: 'AMS/EHAM',
    icao: 'EHAM',
  },
  {
    rank: 15,
    name: 'Frankfurt Airport',
    location: 'Frankfurt, Hesse',
    country: 'Germany',
    countryCode: 'DE',
    code: 'FRA/EDDF',
    icao: 'EDDF',
  },
  {
    rank: 16,
    name: 'Singapore Changi Airport',
    location: 'Changi, East Region',
    country: 'Singapore',
    countryCode: 'SG',
    code: 'SIN/WSSS',
    icao: 'WSSS',
  },
  {
    rank: 17,
    name: 'Suvarnabhumi Airport',
    location: 'Bang Phli, Samut Prakan',
    country: 'Thailand',
    countryCode: 'TH',
    code: 'BKK/VTBS',
    icao: 'VTBS',
  },
  {
    rank: 18,
    name: 'Denver International Airport',
    location: 'Denver, Colorado',
    country: 'United States',
    countryCode: 'US',
    code: 'DEN/KDEN',
    icao: 'KDEN',
  },
  {
    rank: 19,
    name: 'Indira Gandhi International Airport',
    location: 'Delhi',
    country: 'India',
    countryCode: 'IN',
    code: 'DEL/VIDP',
    icao: 'VIDP',
  },
  {
    rank: 20,
    name: 'Soekarno–Hatta International Airport',
    location: 'Tangerang, Banten',
    country: 'Indonesia',
    countryCode: 'ID',
    code: 'CGK/WIII',
    icao: 'WIII',
  },
  {
    rank: 21,
    name: 'John F. Kennedy International Airport',
    location: 'Queens, New York, New York',
    country: 'United States',
    countryCode: 'US',
    code: 'JFK/KJFK',
    icao: 'KJFK',
  },
  {
    rank: 22,
    name: 'Kuala Lumpur International Airport',
    location: 'Sepang, Selangor',
    country: 'Malaysia',
    countryCode: 'MY',
    code: 'KUL/WMKK',
    icao: 'WMKK',
  },
  {
    rank: 23,
    name: 'Madrid Barajas Airport',
    location: 'Barajas, Madrid',
    country: 'Spain',
    countryCode: 'ES',
    code: 'MAD/LEMD',
    icao: 'LEMD',
  },
  {
    rank: 24,
    name: 'San Francisco International Airport',
    location: 'San Mateo County, California',
    country: 'United States',
    countryCode: 'US',
    code: 'SFO/KSFO',
    icao: 'KSFO',
  },
  {
    rank: 25,
    name: 'Chengdu Shuangliu International Airport',
    location: 'Shuangliu-Wuhou, Chengdu, Sichuan',
    country: 'China',
    countryCode: 'CN',
    code: 'CTU/ZUUU',
    icao: 'ZUUU',
  },
  {
    rank: 26,
    name: 'Shenzhen Bao\'an International Airport',
    location: 'Bao\'an, Shenzhen, Guangdong',
    country: 'China',
    countryCode: 'CN',
    code: 'SZX/ZGSZ',
    icao: 'ZGSZ',
  },
  {
    rank: 27,
    name: 'Orlando International Airport',
    location: 'Orlando, Florida',
    country: 'United States',
    countryCode: 'US',
    code: 'MCO/KMCO',
    icao: 'KMCO',
  },
  {
    rank: 28,
    name: 'McCarran International Airport',
    location: 'Las Vegas, Nevada',
    country: 'United States',
    countryCode: 'US',
    code: 'LAS/KLAS',
    icao: 'KLAS',
  },
  {
    rank: 29,
    name: 'Barcelona–El Prat Airport',
    location: 'Barcelona',
    country: 'Spain',
    countryCode: 'ES',
    code: 'BCN/LEBL',
    icao: 'LEBL',
  },
  {
    rank: 30,
    name: 'Toronto Pearson International Airport',
    location: 'Mississauga, Ontario',
    country: 'Canada',
    countryCode: 'CA',
    code: 'YYZ/CYYZ',
    icao: 'CYYZ',
  },
];
